export const skillCategories = [
  {
    category: "Frontend",
    icon: "frontend",
    skills: [
      { name: "HTML5", level: 95 },
      { name: "CSS3 / SASS", level: 90 },
      { name: "JavaScript (ES6+)", level: 88 },
      { name: "jQuery", level: 90 },
      { name: "AJAX", level: 88 },
      { name: "React.js", level: 75 },
      { name: "Next.js", level: 70 },
    ],
  },
  {
    category: "Backend",
    icon: "backend",
    skills: [
      { name: "PHP", level: 95 },
      { name: "Laravel", level: 92 },
      { name: "CodeIgniter", level: 88 },
      { name: "CakePHP", level: 82 },
      { name: "Node.js", level: 70 },
      { name: "REST APIs", level: 92 },
    ],
  },
  {
    category: "Database",
    icon: "database",
    skills: [
      { name: "MySQL", level: 93 },
      { name: "PostgreSQL", level: 80 },
      { name: "Oracle", level: 70 },
      { name: "MongoDB", level: 68 },
    ],
  },
  {
    category: "CMS & E-commerce",
    icon: "cms",
    skills: [
      { name: "WordPress", level: 96 },
      { name: "WooCommerce", level: 90 },
      { name: "Custom Plugins", level: 93 },
      { name: "Theme Development", level: 92 },
      { name: "Payment Gateways", level: 88 },
    ],
  },
  {
    category: "AI & Automation",
    icon: "ai",
    skills: [
      { name: "OpenAI / LLM APIs", level: 82 },
      { name: "Automation Workflows", level: 85 },
      { name: "Intelligent Features", level: 80 },
    ],
  },
  {
    category: "Cloud & DevOps",
    icon: "cloud",
    skills: [
      { name: "AWS EC2", level: 82 },
      { name: "AWS S3", level: 80 },
      { name: "Git / GitHub", level: 90 },
      { name: "SSL / Hosting", level: 88 },
      { name: "Server Config", level: 82 },
    ],
  },
  {
    category: "Core Strengths",
    icon: "strengths",
    skills: [
      { name: "Performance Optimization", level: 93 },
      { name: "SEO / Core Web Vitals", level: 92 },
      { name: "API Integration", level: 92 },
      { name: "Debugging", level: 90 },
      { name: "Scalable Design", level: 88 },
    ],
  },
];
